module.exports = __webpack_public_path__ + "static/media/PERFECT_logo_newcolor.1f9c6837.svg";